module.exports = __webpack_public_path__ + "img/attachment-icon.a138f917.png";